import { createSelector } from "@reduxjs/toolkit";

import { StoreState } from "../../store";

const selector = (state: StoreState) => state.campaign;

export const campaignSelectors = {
  // 全キャンペーンを取得
  activeCampaigns: createSelector(selector, (state) => state.activeCampaigns),

  // 早割キャンペーンのみ取得
  earlyBirdCampaign: createSelector(
    selector,
    (state) =>
      state.activeCampaigns.find((c) => c.type === "early_bird") || null,
  ),

  // 在庫販売キャンペーンのみ取得
  stockItemCampaign: createSelector(
    selector,
    (state) =>
      state.activeCampaigns.find((c) => c.type === "stock_item") || null,
  ),

  // ソート順に並べたキャンペーン一覧
  sortedActiveCampaigns: createSelector(selector, (campaign) => {
    return [...campaign.activeCampaigns].sort((a, b) => {
      const aOrder = a.sortOrder ?? Infinity;
      const bOrder = b.sortOrder ?? Infinity;
      return aOrder - bOrder;
    });
  }),

  // キャンペーン選択画面での選択完了フラグ
  selectionMade: createSelector(selector, (state) => state.selectionMade),
};
